<template>
  <v-container>
    <v-app-bar app>
      <v-spacer></v-spacer>
      <v-btn color="accent" @click="numero_scheda+=1">Avanti</v-btn>
    </v-app-bar>
    <v-flex d-flex xs12 sm12 md12 lg12 xl12 justify-center>
      <h2>VERBALE DI VERIFICA PERIODICA</h2>
    </v-flex>
    <v-flex d-flex xs12 sm12 md12 lg12 xl12 justify-center>
      <h6>(DLgs 81/2088 art...)</h6>
    </v-flex>
    <v-flex d-flex xs12 sm12 md12 lg12 xl12>
      <h4>Verbale n° 145789</h4>
    </v-flex>
    <v-flex xs12 sm12 md12 lg12 xl12>
      <v-stepper v-model="numero_scheda" vertical non-linear>
        <!--Prima scheda - Dati generali sull'impianto-->
        <v-stepper-step editable :complete="numero_scheda > 1" step="1">Dati impianto</v-stepper-step>
        <v-stepper-content step="1">
          <ConfirmDialog ref="confirm"></ConfirmDialog>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center class="space-up">
            <v-dialog
              ref="dialogDataVerifica"
              v-model="dialogDataVerifica"
              :return-value.sync="dataVerifica"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="dataVerifica" label="Data" readonly v-on="on" outlined></v-text-field>
              </template>
              <v-date-picker v-model="dataVerifica" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dialogDataVerifica = false">Chiudi</v-btn>
                <v-btn text color="primary" @click="$refs.dialogDataVerifica.save(dataVerifica)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-text-field label="Nome e cognome operatore" v-model="nomeOperatore" outlined></v-text-field>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <h4>Tipo verifica</h4>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-radio-group v-model="tipoVerifica">
              <v-radio label="Prima verifica periodica" value="Prima verifica"></v-radio>
              <v-radio
                label="Verifica periodica(Successiva alla prima)"
                value="Verifica successiva"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <h4>Dati impianto</h4>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-text-field label="Matricola" outlined v-model="matricola"></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field label="Installatore" outlined v-model="installatore"></v-text-field>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-text-field label="Ditta" outlined v-model="ditta"></v-text-field>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-text-field label="Comune" outlined v-model="comune"></v-text-field>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-text-field label="Via" outlined v-model="via"></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field label="N°" type="number" outlined v-model="numeroCivico"></v-text-field>
          </v-flex>
          <v-btn color="primary" @click="numero_scheda = 2">Avanti</v-btn>
          <v-btn text>Indietro</v-btn>
        </v-stepper-content>
        <!--Fine prima scheda-->

        <!--Seconda scheda - Configurazione e dati tecnici rilevati al momento della verifica-->
        <v-stepper-step
          :complete="numero_scheda > 2"
          step="2"
          editable
        >Configurazione e dati tecnici rilevati al momento della verifica</v-stepper-step>

        <v-stepper-content step="2">
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">N° Ordine</th>
                    <th class="text-left">Tipo Generatori</th>
                    <th class="text-left">Costruttore</th>
                    <th class="text-left">Numero di fabbrica</th>
                    <th class="text-left">Pressione max d'esercizio(bar)</th>
                    <th class="text-left">Tipo Combustibile</th>
                    <th class="text-left">Potenzialità del focolare</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="generatori.length==0">
                    <td colspan="7">Nessun dato</td>
                  </tr>
                  <tr v-else v-for="(generatore,index) in generatori" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{ generatore.tipo }}</td>
                    <td>{{ generatore.costruttore }}</td>
                    <td>{{ generatore.numFabbrica }}</td>
                    <td>{{ generatore.pressioneMax }}</td>
                    <td>{{ generatore.tipoCombustibile }}</td>
                    <td>{{ generatore.potenzialita }}</td>
                    <td>
                      <v-btn icon>
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-btn color="accent" @click="dialogGeneratori=true">Aggiungi</v-btn>
          </v-flex>
          <br />
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-textarea outlined label="Matricole dei vasi collaudati" v-model="matricoleVasi"></v-textarea>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-checkbox
              v-model="certificazione"
              label="Gli impianti rispettano, qualora non certificati come insiemi, le prescrizioni della Raccolta R dell'ISPSEL"
            ></v-checkbox>
          </v-flex>
          <br />
          <v-btn color="primary" @click="numero_scheda = 3">Avanti</v-btn>
          <v-btn text @click="numero_scheda = 1">Indietro</v-btn>
        </v-stepper-content>
        <!--Fine seconda scheda-->

        <!--Terza scheda - Regolarità e funzionalità dei dispositivi di protezione-->
        <v-stepper-step
          editable
          :complete="numero_scheda > 3"
          step="3"
        >Regolarità e funzionalità dei dispositivi di protezione</v-stepper-step>

        <v-stepper-content step="3">
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
            <v-textarea outlined label="Accessori di sicurezza" v-model="accessoriSicurezza"></v-textarea>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-textarea outlined label="Dispositivi di controllo" v-model="dispositiviControllo"></v-textarea>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-textarea
              outlined
              label="Dispositivi di regolazione"
              v-model="dispositiviRegolazione"
            ></v-textarea>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <v-textarea outlined label="Altri accessori rilevanti" v-model="altriAccessori"></v-textarea>
          </v-flex>
          <v-btn color="primary" @click="numero_scheda = 4">Avanti</v-btn>
          <v-btn text>Indietro</v-btn>
        </v-stepper-content>
        <!--Fine terza scheda-->

        <!--Quarta scheda - Stato di conservazione-->
        <v-stepper-step editable step="4" :complete="numero_scheda > 4">Stato di conservazione</v-stepper-step>
        <v-stepper-content step="4">
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
            <v-textarea
              outlined
              label="Lo stato di conservazione risulta"
              v-model="statoConservazione"
            ></v-textarea>
          </v-flex>
          <v-btn color="primary" @click="numero_scheda = 5">Avanti</v-btn>
          <v-btn text>Indietro</v-btn>
        </v-stepper-content>
        <!--Fine quarta scheda-->

        <!--Quinta scheda - Osservazioni-->
        <v-stepper-step editable step="5" :complete="numero_scheda > 5">Osservazioni</v-stepper-step>
        <v-stepper-content step="5">
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
            <v-textarea outlined label="Osservazioni" v-model="osservazioni"></v-textarea>
          </v-flex>
          <v-btn color="primary" @click="numero_scheda = 6">Avanti</v-btn>
          <v-btn text>Indietro</v-btn>
        </v-stepper-content>
        <!--Fine quinta scheda-->

        <!--Sesta scheda - Esito della verifica -->
        <v-stepper-step editable step="6" :complete="numero_scheda > 6">Esito della verifica</v-stepper-step>
        <v-stepper-content step="6">
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
            <h4>In base a quanto rilevato</h4>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-radio-group v-model="statoVerificato">
              <v-radio label="lo stato di funzionamento"></v-radio>
              <v-radio label="lo stato di conservazione"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12>
            <h4>l'impianto</h4>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-radio-group v-model="adeguatezza">
              <v-radio label="risulta adeguato"></v-radio>
              <v-radio label="non risulta adeguato"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-dialog
              ref="dialogDataScadenza"
              v-model="dialogDataScadenza"
              :return-value.sync="dataScadenza"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataScadenza"
                  label="Scadenza prossima verifica"
                  readonly
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="dataScadenza" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dialogDataScadenza = false">Chiudi</v-btn>
                <v-btn text color="primary" @click="$refs.dialogDataScadenza.save(dataScadenza)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-text-field label="Luogo" outlined></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog
              ref="dialogDataDocumento"
              v-model="dialogDataDocumento"
              :return-value.sync="dataDocumento"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataDocumento"
                  label="Data"
                  readonly
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="dataDocumento" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dialogDataDocumento = false">Chiudi</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogDataDocumento.save(dataDocumento)"
                >OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-btn color="primary" @click="numero_scheda = 7">Avanti</v-btn>
          <v-btn text>Indietro</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="7" :complete="numero_scheda > 7">Firme</v-stepper-step>
        <v-stepper-content step="7">
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <h4>Firma Verificatore</h4>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <VueSignaturePad
              style="border: 1px solid #6c757d"
              id="signature"
              width="50%"
              height="75%"
              ref="firmaVerificatore"
            />
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-btn color="error" @click="$refs.firmaVerificatore.undoSignature()">Cancella firma</v-btn>
          </v-flex>
          <br />
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <h4>Firma del datore di lavoro o suo rappresentante</h4>
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <VueSignaturePad
              style="border: 1px solid #6c757d"
              id="firmaDatore"
              width="50%"
              height="75%"
              ref="firmaDatore"
            />
          </v-flex>
          <v-flex d-flex xs12 sm12 md12 lg12 xl12 align-center>
            <v-btn color="error" @click="$refs.firmaDatore.undoSignature()">Cancella firma</v-btn>
          </v-flex>
          <br />
          <v-btn color="primary" @click="numero_scheda = 1">Avanti</v-btn>
          <v-btn text>Indietro</v-btn>
        </v-stepper-content>
      </v-stepper>
    </v-flex>

    <!--Dialog per l'inserimento del generatore-->
    <v-dialog v-model="dialogGeneratori">
      <v-card>
        <v-card-title>
          <span class="headline">Aggiungi generatore</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-flex d-flex>
              <v-select
                outlined
                :items="tipoGeneratori"
                item-text="name"
                item-value="id"
                label="Tipo Generatore"
                v-model="generatore['tipo']"
              ></v-select>
              <v-spacer></v-spacer>
              <v-text-field outlined label="Costruttore" v-model="generatore['costruttore']"></v-text-field>
              <v-spacer></v-spacer>
              <v-text-field outlined label="Numero di fabbrica" v-model="generatore['numFabbrica']"></v-text-field>
            </v-flex>
            <v-flex d-flex>
              <v-text-field
                type="number"
                outlined
                label="Pressione Max"
                v-model="generatore['pressioneMax']"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-select
                outlined
                :items="tipoCombustibile"
                item-text="name"
                item-value="id"
                label="Tipo Combustibile"
                v-model="generatore['tipoCombustibile']"
              ></v-select>
              <v-spacer></v-spacer>
              <v-text-field type="number" outlined label="Potenzialità focolare"></v-text-field>
            </v-flex>
            <v-flex d-flex>
              <v-btn color="success" @click="aggiungiGeneratore">Aggiungi</v-btn>
              <v-btn color="error" @click="closeDialogGeneratori">Elimina</v-btn>
            </v-flex>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/*eslint-disable  */
import DataPicker from '../components/DataPicker'
import ConfirmDialog from '../components/ConfirmDialog'

export default {
  components:{
    DataPicker,
    ConfirmDialog
  },
  data() {
    return {
      /*v-model*/
      dataVerifica: new Date().toISOString().substr(0, 10),
      dataScadenza: new Date().toISOString().substr(0, 10),
      dataDocumento: new Date().toISOString().substr(0, 10),
      nomeOperatore: "",
      tipoVerifica: "",
      matricola: "",
      installatore: "",
      ditta: "",
      comune: "",
      via: "",
      matricoleVasi: "",
      certificazione: false,
      numeroCivico: "",
      accessoriSicurezza: "",
      dispositiviControllo: "",
      dispositiviRegolazione: "",
      altriAccessori: "",
      statoConservazione: "",
      osservazioni: "",
      statoVerificato: "",
      adeguatezza: "",
      menu: false,
      dialogDataVerifica: false,
      dialogDataScadenza: false,
      dialogDataDocumento: false,
      numero_scheda: 1,
      generatori: [],
      generatore: {
        ordine: 0,
        tipo: "",
        costruttore: "",
        numFabbrica: "",
        pressioneMax: 0,
        tipoCombustibile: 0,
        potezialita: 0
      },
      dialogGeneratori: false,
      tipoGeneratori: [
        {
          id: "A",
          name: "A tubi d'acqua"
        },
        {
          id: "F",
          name: "A tubi di fumo"
        },
        {
          id: "G",
          name: "Ad elementi di ghisa"
        },
        {
          id: "V",
          name: "Altri tipi"
        }
      ],
      tipoCombustibile: [
        {
          id: 1,
          name: "Carbon fossile"
        },
        {
          id: 2,
          name: "Olio combustibile"
        },
        {
          id: 3,
          name: "Gasolio"
        },
        {
          id: 4,
          name: "Metano"
        },
        {
          id: 5,
          name: "Gas di Città"
        },
        {
          id: 6,
          name: "GPL"
        },
        {
          id: 9,
          name: "Altro tipo"
        }
      ]
    };
  },
  methods: {
    verificaPasso() {
      return false;
    },
    closeDialogGeneratori() {
      this.dialogGeneratori = false;
      this.generatore = {
        ordine: 0,
        tipo: "",
        costruttore: "",
        numFabbrica: "",
        pressioneMax: 0,
        tipoCombustibile: 0,
        potezialita: 0
      };
    },
    aggiungiGeneratore() {
      this.generatore.ordine = this.generatori.length + 1;
      this.generatori.push(this.generatore);
      this.closeDialogGeneratori();
    }
  },
  computed: {
    dataJson: function() {
      let dataJson = {
        dataVerifica:this.dataVerifica,
        dataScadenza:this.dataScadenza,
        dataDocumento:this.dataDocumento, 
        nomeOperatore:this.nomeOperatore,
        tipoVerifica:this.tipoVerifica,
        matricola:this.matricola,
        installatore:this.installatore,
        ditta:this.ditta,
        comune:this.comune,
        via:this.via,
        numeroCivico:this.numeroCivico,
        generatori:this.generatori,
        matricoleVasi:this.matricoleVasi,
        certificazione:this.certificazione,
        accessoriSicurezza:this.accessoriSicurezza,
        dispositiviControllo:this.dispositiviControllo,
        dispositiviRegolazione:this.dispositiviRegolazione,
        altriAccessori:this.altriAccessori,
        statoConservazione:this.statoConservazione,
        osservazioni:this.osservazioni,
        statoVerificato:this.statoVerificato,
        adeguatezza:this.adeguatezza,
        luogo:this.luogo,
        firmaVerificatore:"",
        firmaDatore:"",
      }
      return dataJson;
    }
  },
  created() {
    this.$vuetify.lang.current = "it";
  },
};
</script>
<style>
.space-up {
  padding-top: 5px;
}
</style>